import { BaseNote } from './base-note.dto';
import { Company } from './company.dto';

export class CompanyNote extends BaseNote {
  company?: Company;
}
